export function juntarTextosVoucher(observations, hallazgos) {
  const items = [];
  if (observations && observations.trim())
    items.push({ key: 'general', label: 'Observaciones', text: observations });
  (hallazgos || []).forEach((h, i) => {
    if (h?.descripcion && h.descripcion.trim()) {
      items.push({ key: `hallazgo:${i}`, label: `Hallazgo ${i + 1}`, text: h.descripcion });
    }
  });
  return items;
}

export function aplicarTextosVoucher(finales, observations, hallazgos) {
  let obs = observations;
  if (finales && Object.prototype.hasOwnProperty.call(finales, 'general')) obs = finales.general;
  const next = (hallazgos || []).map((h, i) => {
    const k = `hallazgo:${i}`;
    return finales && Object.prototype.hasOwnProperty.call(finales, k)
      ? { ...h, descripcion: finales[k] }
      : h;
  });
  return { observations: obs, hallazgos: next };
}
